<template>
	<div class="bind-phone-page">
		<div class="bind-container">
			<h3>绑定手机号</h3>
			<div class="form-group">
				<input type="text" placeholder="请输入手机号" v-model="form.phone" />
			</div>
			<div class="form-group code-group">
				<input type="text" placeholder="请输入验证码" v-model="form.code" />
				<button class="send-btn" @click="sendCode" :disabled="isSending">{{ codeText }}</button>
			</div>
			<button class="submit-btn" @click="handleBind">确认绑定</button>
		</div>
	</div>
</template>

<script>
	import { sendCode, bindPhone } from '@/api/user' // 假设有 bindPhone 接口
	import { ElMessage } from 'element-plus'
	import 'element-plus/es/components/message/style/css'
	import eventBus from '@/utils/eventBus'

	export default {
		name: 'BindPhone',
		data() {
			return {
				form: {
					phone: '',
					code: ''
				},
				isSending: false,
				codeText: '获取验证码',
				timer: null,
				tempKey: ''
			}
		},
		created() {
			this.tempKey = this.$route.query.key
			if (!this.tempKey) {
				ElMessage.error('无效的请求')
				this.$router.replace('/')
			}
		},
		methods: {
			async sendCode() {
				if (!this.form.phone) {
					ElMessage.warning('请输入手机号')
					return
				}
				if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
					ElMessage.warning('请输入正确的手机号')
					return
				}
				
				this.isSending = true
				try {
					await sendCode({ phone: this.form.phone, type: 3 }) // 假设 type 3 为绑定手机
					let count = 60
					this.codeText = `${count}s`
					this.timer = setInterval(() => {
						count--
						if (count > 0) {
							this.codeText = `${count}s`
						} else {
							clearInterval(this.timer)
							this.isSending = false
							this.codeText = '获取验证码'
						}
					}, 1000)
				} catch (error) {
					this.isSending = false
					ElMessage.error(error.message || '发送失败')
				}
			},
			async handleBind() {
				if (!this.form.phone || !this.form.code) {
					ElMessage.warning('请填写完整信息')
					return
				}
				
				try {
					// 调用绑定接口，需要传 tempKey 和手机号验证码
					// 这里假设接口名为 bindPhone
					// 如果后端是同一个 callback 接口处理绑定，逻辑会不同
					// 假设有一个专门的绑定接口
					const res = await bindPhone({
						phone: this.form.phone,
						code: this.form.code,
						key: this.tempKey
					})
					
					if (res && res.token) {
						localStorage.setItem('token', res.token)
						if (res.userInfo) {
							localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
						}
						ElMessage.success('绑定成功')
						eventBus.emit('login-success')
						this.$router.replace('/')
					}
				} catch (error) {
					ElMessage.error(error.message || '绑定失败')
				}
			}
		}
	}
</script>

<style scoped>
	.bind-phone-page {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f5f5f5;
	}
	.bind-container {
		background: #fff;
		padding: 40px;
		border-radius: 8px;
		width: 400px;
		box-shadow: 0 4px 12px rgba(0,0,0,0.1);
	}
	h3 {
		text-align: center;
		margin-bottom: 30px;
		color: #333;
	}
	.form-group {
		margin-bottom: 20px;
	}
	.form-group input {
		width: 100%;
		padding: 12px;
		border: 1px solid #ddd;
		border-radius: 4px;
		box-sizing: border-box;
	}
	.code-group {
		display: flex;
		gap: 10px;
	}
	.send-btn {
		white-space: nowrap;
		padding: 0 15px;
		background: #fff;
		border: 1px solid #ff9900;
		color: #ff9900;
		border-radius: 4px;
		cursor: pointer;
	}
	.send-btn:disabled {
		border-color: #ddd;
		color: #999;
		cursor: not-allowed;
	}
	.submit-btn {
		width: 100%;
		padding: 12px;
		background: #ff9900;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
	}
	.submit-btn:hover {
		background: #e68a00;
	}
</style>